import { MarketInsightsIcon } from '@hcs/design-system';
import { AppConfig, AppSlugs } from '@hcs/types';

import MarketInsightsProductImage from '../../assets/product-images/market-insights-image.jpg';

export const APP_CONFIG_MARKET_INSIGHTS: AppConfig = {
  name: 'Market Insights',
  applicationKey: 'market-insights',
  type: 'product',
  globalHeaderTitle: 'Market Insights',
  appSlugForEngagement: AppSlugs.MarketInsights,
  rootPath: '/market-insights',
  Icon: MarketInsightsIcon,
  descriptionLong:
    'Explore data-driven market trends at the zipcode and MSA level, updated weekly.',
  descriptionShort:
    'Explore data-driven market trends at the zipcode and MSA level, updated weekly.',
  marketingImage: MarketInsightsProductImage,
};

export const VIEW_PATHS_MARKET_INSIGHTS = {
  SEARCH: 'search',
  MSAS: 'msas',
  MSA_REPORT: 'msas/:msaId',
  CITY_REPORT: 'cities/:placeId',
  PDFS: '/market-insights/pdf',
  ZIPS: 'msas/:msaId/zips',
  ZIP_REPORT: 'zips/:zipcode',
} as const;
